var React = require('react');

function Aws (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.63 31.388l-7.135-2.56V18.373l7.135 2.43zm1.3 0l7.135-2.56V18.373l-7.135 2.432zm-7.7-13.8l7.2-2.033 6.696 2.16-6.696 2.273zm-2.092-.8L0 14.22V3.75l7.135 2.43zm1.307 0l7.135-2.56V3.75L8.443 6.192zm-7.7-13.8l7.2-2.043 6.696 2.16-6.696 2.273zm23.052 13.8l-7.135-2.56V3.75l7.135 2.43zm1.3 0l7.135-2.56V3.75l-7.135 2.43zm-7.7-13.8l7.2-2.033 6.696 2.16-6.696 2.273z","fill":"#f90","fillRule":"evenodd"}));
}

Aws.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Aws;

Aws.default = Aws;
